import Card from '@/components/elements/Card/Card';
import { Button } from '@/components/elements/forms/buttons';
import Alert from '@/components/elements/notifications/Alert/Alert';
import Icon from '@/components/icons/Icon';
import { APP_ROUTES, ROUTE_BUILDER } from '@/constants/pages';
import { getImageContain, getPlaceImage } from '@/helpers';
import { _s } from '@/locale';
import { Place } from '@/types/state/shared';
import { Link } from 'react-router-dom';

const baseTranslationKey = 'features.ProfilePages.components.PlaceDetails';

const PlaceDetails = ({
  place,
  isVerified,
  isPremium,
  isBasic,
  onAddWebSiteClick,
}: {
  place: Place;
  isVerified: boolean;
  isPremium?: boolean;
  isBasic?: boolean;
  onAddWebSiteClick?: () => void;
}) => {
  const placeLogo = getImageContain(getPlaceImage(place), 'logoBig');
  return (
    <Card size="lg">
      <div className="gap-xl flex flex-col">
        {placeLogo && (
          <div className="flex justify-center">
            <a
              href="#photos"
              aria-label={_s('photos')}
              className="bg-black-50 relative flex h-[270px] w-[270px] items-center justify-center overflow-hidden rounded-md">
              <img
                width="100%"
                height="100%"
                src={placeLogo}
                alt=""
                loading="lazy"
                style={{
                  maxWidth: '100%',
                  maxHeight: '100%',
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  display: 'block',
                }}
                onError={(e) => (e.currentTarget.src = '/images/bd-fallback-img200x200.png')}
              />
            </a>
          </div>
        )}
        {!isPremium && !isBasic && !isVerified && (
          <Button
            size="md"
            onClick={onAddWebSiteClick}
            iconNoFilter
            rightIcon={<Icon variant="website" color="fg_primary_inverse" />}
            label={_s(`${baseTranslationKey}.cta`)}
          />
        )}
        {isVerified &&
          Boolean(place?.about?.associations?.length) &&
          place.about.associations.map((association) => {
            return (
              <Link
                key={association.id}
                to={
                  association.slug
                    ? ROUTE_BUILDER.associationLanding(association.slug)
                    : APP_ROUTES.ASSOCIATION_PAGES_ARCHIVE
                }>
                <Alert
                  className="p-sm bg-surface_l4"
                  leftSlot={
                    <div className="gap-xs flex flex-col">
                      <div className="gap-2xs flex items-center">
                        <Icon size="xs" variant="industry-organization" color="fg_secondary"></Icon>
                        <span className="text-xxs text-fg_secondary">{_s(`${baseTranslationKey}.alert`)}</span>
                      </div>
                      <div className="text-m text-fg_primary">{association.name}</div>
                    </div>
                  }
                  variant="information"
                  rightSlot={<img className="h-[28px] w-auto" src={association.imgSrc} alt={association.name} />}
                />
              </Link>
            );
          })}
      </div>
    </Card>
  );
};

export default PlaceDetails;
